import Complain from './src/main';

/* istanbul ignore next */
Complain.install = function(Vue) {
  Vue.component(Complain.name, Complain);
};

export default Complain;
